import { render, staticRenderFns } from "./DeletedPurchasesBrowse.vue?vue&type=template&id=3129ceb0&scoped=true"
import script from "./DeletedPurchasesBrowse.vue?vue&type=script&lang=ts"
export * from "./DeletedPurchasesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./DeletedPurchasesBrowse.vue?vue&type=style&index=0&id=3129ceb0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129ceb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3129ceb0')) {
      api.createRecord('3129ceb0', component.options)
    } else {
      api.reload('3129ceb0', component.options)
    }
    module.hot.accept("./DeletedPurchasesBrowse.vue?vue&type=template&id=3129ceb0&scoped=true", function () {
      api.rerender('3129ceb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/DeletedPurchasesBrowse.vue"
export default component.exports